// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".animate-spin{transform-origin:center;animation:rotateAnimation 1s linear infinite}@keyframes rotateAnimation{to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
